import React, { useContext } from "react";
import { AuthContext } from "../context/UserContext";
import Button from "react-bootstrap/Button";
import "./home.css";
import { Link } from "react-router-dom";
import { FaBook, FaDiscourse } from "react-icons/fa";

const Home = () => {
  const { user } = useContext(AuthContext);
  console.log("user", user);
  return (
    <div className="default mt-5">
      <div className="ms-5">
        <h5 className="pb-3 text-secondary mb-4">Best IT Training Institute in the country</h5>
        <h2 className="text-primary opacity-75">Let the career begin</h2>
        <h1 className="fw-bold text-warning ">Confidence in skills</h1>
        <p className="pt-4 mt-4">
          With experienced mentors and updated curriculum, Schooling Institute
          is ready to advance your career. Choose your preferred course today
          from our more than 5 trendy courses.
        </p>
        <div className="d-flex justify-space-around mt-5 ms-0 ">
            <Button className="bg-light fw-bold text-success border-secondary fw-normal shadow-lg ms-2 pt-2 pb-2 ps-4 pe-4">
              50000+{" "}
              <span className="fw-normal">
                {" "}
                <br /> Successfull Students
              </span>
            </Button>
            <Button className="bg-light fw-bold text-success border-secondary fw-normal shadow-lg ms-3 pt-2 pb-2 ps-4 pe-4">
              300+{" "}
              <span className="fw-normal">
                {" "}
                <br />Industry Expert
              </span>
            </Button>
          </div>
      </div>
      
      <div className="ratio ratio-16x9 ms-0">
       <iframe className="ms-5 mt-5 rounded-4 h-75 w-75 shadow-lg" src="https://www.youtube-nocookie.com/embed/IfZZjTdn1XM?autoplay=1" allow="autoplay" title="YouTube video player" frameborder="0"  allowfullscreen></iframe>
      </div>
      
      <Button className="btn btn-primary ms-5 w-50">
        <Link to="/courses" className="text-white text-decoration-none">
        <FaBook className="pe-1"></FaBook> Browse Courses
        </Link>
      </Button>
    </div>
  );
};

export default Home;
